type RecaptchaWindow = Window & {
  recaptchaOptions?: {
    useRecaptchaNet?: boolean;
  };
};

export function configureRecaptchaForLocale(locale: string): void {
  if (locale === 'en-ap') {
    (window as RecaptchaWindow).recaptchaOptions = { useRecaptchaNet: true };
  }
}
